const canUseDOM = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement && window.env.NODE_ENV !== 'test');

export default canUseDOM;
